<template>


    <div class="widgets-page">

        <GenericPostType
                :uid="activity.uid"
                :createdOn="activity.createdOn"
        >
                        <span slot="nextToName">
                commented on a photo
            </span>

            <h5>
                {{activity.source.object.description}}
            </h5>
            <div class=" widget-top-overflow text-white">
                <a :href="activity.source.url">
                    <img :src='thumbPath' alt="..."/>
                </a>
                <ul class="tags text-white pull-right">
                    <li><a href="#">design</a></li>
                    <li><a href="#">white</a></li>
                </ul>
            </div>

            <div slot="comments-thread">
                <comments-thread
                        thread-collection="medias"
                        :selected-id="activityCommentId"
                        :thread-id="activity.source.id">

                </comments-thread>

            </div>
        </GenericPostType>

    </div>
</template>


<script>
  const fb        = require('@/firebaseConfig.js')
  const CommonLib = require('@/lib/Common')

  import Vue from 'vue'
  import Moment from 'moment'
  import VueTimeago from 'vue-timeago'
  import Likes from '@/components/Likes/Likes'
  import GenericPostType from '@/components/Posts/Types/GenericPostType'
  import CommentsThread from '../../Comments/CommentsThread'

  export default {
    name:       'MediaPostType',
    components: {
      Likes,
      GenericPostType,
      CommentsThread,
    },
    props:      {
      'activity': Object,
    },
    data ()
    {
      return {
        commentText: '',
      }
    },
    mounted ()
    {
      var that = this
      this.retreiveComment(this.activity.contents.commentId).then(function (comment) {
        that.commentText = comment.text

      })

    },
    filters:    {},
    computed:   {

      activityCommentId ()
      {
        if (this.activity.contents && this.activity.contents.commentId)
        {
          return this.activity.contents.commentId
        }
        return this.activity.id
      },
      thumbPath ()
      {
        return CommonLib.getImageURL(this.activity.source.object.thumbsPath[800])
      },
      currentUserProfile ()
      {
        return this.$store.getters.currentUserProfile

      },
      currentUser ()
      {
        return this.$store.getters.currentUser
      },

    },
    methods:    {
      retreiveComment (commentId)
      {
        return new Promise(function (resolve, reject) {

          fb.commentsCollection.doc(commentId)
            .onSnapshot(function (doc) {

              if (!doc.exists)
              {
                reject()
                return
              }
              var comment = doc.data()
              comment.id  = doc.id

              resolve(comment)
            })

        })
      },

    },
    watch:      {}
  }

</script>
<style src="@/pages/Profile/Profile.scss" lang="scss" scoped/>

<style scoped>
    .eventImage img {
        width: 100%;
        height: auto;
    }

    .eventFooter {
        margin-top: 0px;
    }

    .widget-top-overflow {
        margin-top: 0;
    }

    .widgets-page .widget-top-overflow .tags {
        position: absolute;
        bottom: 0;
        right: 0;
        margin: 20px;
    }

</style>
